/* Per-accessory text for site/accessory.html (Sava 29 Oct): desc under the build box, 4 Questions, 4 Details.
   Generated from _build/accessory-content.json; edit the JSON, then rebuild this file. */
window.CF_ACC_CONTENT={
 "kc": {
  "desc": "A tiny full-body version of them, hanging from their keys. Same face, same outfit, sculpted by hand from your photo. A sweet everyday gift for anyone who never leaves home without their keys.\n\nGot a pet? Pick Pet and we sculpt them whole, sitting, with their ears, markings, eye color and collar matched to your photo. Same size as the person keychain, with a steady head, on the same key ring.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the keychain by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the keychain, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "Person: a clear, front-facing face photo and a full-body photo in the outfit you want. A side profile helps the likeness too. Pet: one clear photo of your pet with the face and markings in view. A second photo from the side helps with the colors."
   ],
   [
    "What arrives at my door?",
    "Your keychain figure on its key ring, packed in a gift box and sent tracked to your door."
   ]
  ],
  "details": [
   [
    "What's included",
    "The hand-sculpted keychain figure on a key ring, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The figure is about 3.1 to 3.9 in (8 to 10 cm) tall. Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "It's a keepsake, so it doesn't love being dropped. Keep it off hard floors and out of water, and wipe it with a soft dry cloth."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "bo": {
  "desc": "Their sculpted head and shoulders on top of a working bottle opener. Every cold drink comes with a grin. Made for the dad, brother or best friend who's always the one opening the bottles.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the head by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the opener, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face is the most important one. A side profile helps the likeness too. Glasses, a beard or a favorite hoodie on the shoulders? Add it in the note for the artist in your cart."
   ],
   [
    "What arrives at my door?",
    "Your bottle opener with their face on top, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The bottle opener with their bust sculpted by hand on top, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The head and shoulders are hand-built in non-toxic polymer clay, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Wipe the opener end clean with a damp cloth. Keep the clay head out of water and the dishwasher."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "ws": {
  "desc": "A wine stopper topped with a small clay version of their face, sculpted by hand from your photo. It keeps the bottle closed and makes everyone at the table laugh. Sold on its own, no mini needed.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the face by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the stopper, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face is the most important one. A side profile helps the likeness too. Show us the top you want on the shoulders if it matters."
   ],
   [
    "What arrives at my door?",
    "Your wine stopper with their face on top, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The wine stopper with their bust sculpted by hand on top, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The head and shoulders are hand-built in non-toxic polymer clay, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Rinse the stopper end by hand. Keep the clay head dry and out of the dishwasher."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "orn": {
  "desc": "Your whole family on one round ornament, sculpted by hand from a single photo. Add your names or the year and it becomes the one everyone looks for on the tree. A lovely first-Christmas or new-family gift.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the ornament by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else. For Christmas in the US, order early: the Standard mini deadline is Fri Nov 13."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the ornament, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "One clear family photo with everyone's face visible works well. Extra close-ups of each person help the likeness."
   ],
   [
    "What arrives at my door?",
    "Your ornament with its ribbon, ready to hang, in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The hand-sculpted family ornament with a ribbon to hang it, your names or year for free, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The faces are sculpted in relief. Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Hang it on a sturdy branch so it can't fall. After the holidays, wrap it in soft tissue and store it in its box."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "orn-me": {
  "desc": "A tiny full-body version of them, hanging on your tree. Their face and hair are sculpted by hand from your photo, and the outfit comes from the one you pick: Santa suit, Elf, Ugly sweater and more. It's the ornament everyone looks for first, every December.\n\nOne of our 20+ artists shapes the whole ornament in polymer clay and paints every detail by hand, with no 3D printing. Before we finish, a free face proof lands in your inbox, and we keep tweaking it until you love it. It arrives in a gift box on a red cord, ready to hang.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the ornament by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else. For Christmas in the US, order by Nov 13."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the ornament, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "One clear, front-facing photo of their face. A side profile helps the likeness too. The outfit comes from the design, so no full-body photo is needed."
   ],
   [
    "Can I pick a different outfit for each person?",
    "Yes. Each ornament is one person, so add one per person and pick an outfit for each."
   ],
   [
    "What arrives at my door?",
    "Your ornament on its red cord, ready to hang, in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The hand-sculpted ornament on a red cord, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "About 3.9 in (10 cm) tall, head to feet. Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "It's a keepsake, so it doesn't love being dropped. Hang it on a sturdy branch, keep it away from water, and wipe it with a soft dry cloth. Store it in its gift box after the holidays."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "ps": {
  "desc": "A full-body mini of them on a round base, holding up your phone. It turns a desk or nightstand into something that makes you smile every time you check a message. Great for the coworker, gamer or teen who is always on their phone.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the stand by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the figure, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing face photo and a full-body photo in the outfit you want. A side profile helps the likeness too."
   ],
   [
    "What arrives at my door?",
    "Your phone stand figure, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The hand-sculpted phone stand figure on its base, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Set the phone in gently rather than dropping it in. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "usb": {
  "desc": "A 64GB USB stick with their mini standing on top, sculpted by hand from your photo. Fill it with wedding photos, family videos or a playlist and the gift holds the memories too. A sweet pick for couples and anniversaries.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the mini on top by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the mini, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing face photo and a full-body photo of each person on top, in the outfits you want."
   ],
   [
    "What arrives at my door?",
    "Your USB stick with the mini on top and its cap, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The 64GB USB stick with the hand-sculpted mini on top, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "64GB of storage. The mini on top is hand-built in non-toxic polymer clay, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Hold it by the base, not the figure, when you plug it in or pull it out. Keep it dry."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "case": {
  "desc": "A clear display case that keeps your mini dust-free and safe from little hands. Pick it plain, or with an LED light in the base that makes the mini glow on a shelf at night. The finishing touch for a mini you want to keep for years.",
  "faq": [
   [
    "How long until it's in my hands?",
    "It ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "There's nothing to proof on the case itself. The mini that goes inside still gets its free face proof."
   ],
   [
    "What photo should I send?",
    "No photo needed for the case. Just add it to your order with your mini."
   ],
   [
    "What arrives at my door?",
    "The clear case and its base, with the LED light if you picked it, sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "A clear display case with a base. Plain for $35, or with an LED light for $49."
   ],
   [
    "Size & materials",
    "A clear cover on a solid base, sized to hold a mini."
   ],
   [
    "Care tips",
    "Dust it with a soft dry cloth. Skip glass cleaners and rough sponges so the cover stays clear."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "memorial": {
  "desc": "A gentle keepsake of your pet, sculpted by hand from their photo and kept in a clear case with a nameplate. Add their name and dates and it becomes a quiet place to remember them. Memorial orders are handled with extra care.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your pet by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish your pet, a free proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited. Memorial orders are handled with extra care."
   ],
   [
    "What photo should I send?",
    "A clear photo of their face and a full-body photo. A second angle helps us get the markings right, and older or printed photos usually work too."
   ],
   [
    "What arrives at my door?",
    "Your pet's figure in its case with the nameplate, packed with care in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "Your pet, sculpted by hand, in a clear display case with a nameplate for their name and dates (free), a free proof and a gift box."
   ],
   [
    "Size & materials",
    "The pet is hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "The case keeps it dust-free. Wipe the cover with a soft dry cloth and keep it out of strong direct sun."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "topper": {
  "desc": "The two of you on top of your wedding cake, sculpted by hand from your photo and standing on their own base. It's not edible, so lift it off before the cake is cut. After the big day it moves from the cake to a shelf at home. Made for couples who want a topper that actually looks like them.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the two of you by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else. Order well before the wedding date so there's time for the proof."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the topper, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear face photo and a full-body photo of each of you. Photos of the dress and suit help a lot, or just tell us what you're wearing."
   ],
   [
    "What arrives at my door?",
    "Your cake topper duo on its own base, with your names and date, in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "A hand-sculpted duo of the two of you on their own base, your names and wedding date for free, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The figures are hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing. They stand on their own base. Not edible: polymer clay is not food safe."
   ],
   [
    "Care tips",
    "Not edible. Set it on the cake just before the reception, then lift it off before cutting. Keep it out of the fridge and away from heat."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "frame": {
  "desc": "Your mini set in a framed shadow box, ready to hang on the wall. Add names or a date and it reads like a family portrait you can almost touch. A warm housewarming, anniversary or grandparents' gift.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your mini by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish your mini, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "One clear photo of everyone, with each face visible. Close-ups of each person help the likeness."
   ],
   [
    "What arrives at my door?",
    "Your mini in its framed shadow box, with names or a date if you added them, in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The framed shadow box for your mini, names or a date on the frame for free, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The figures inside are hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Hang it on a solid hook away from steamy bathrooms and strong direct sun. Dust the frame with a soft dry cloth."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "gift": {
  "desc": "The Clayfie gift card, for when you want to give a mini but can't pick the idea. They choose what to make, send their own photo and we sculpt it by hand. It comes by email, so it's a last-minute gift that doesn't feel last minute.",
  "faq": [
   [
    "How long until it's in my hands?",
    "It comes by email, so there's no shipping to wait for. When they use it, we sculpt their mini by hand and ship it tracked."
   ],
   [
    "Do I see it before it's finished?",
    "The card itself needs no proof. When they order their mini, the free face proof comes with it on Standard and Faster."
   ],
   [
    "What photo should I send?",
    "No photo needed. They send their own photo when they use the card."
   ],
   [
    "What arrives at my door?",
    "Nothing by post. The gift card is delivered by email."
   ]
  ],
  "details": [
   [
    "What's included",
    "A Clayfie gift card for $119, $169, $299 or $429, delivered by email."
   ],
   [
    "Size & materials",
    "It's a digital card, so there's nothing to wrap. No photo, no sculpting until they use it."
   ],
   [
    "Care tips",
    "Keep the email somewhere safe until they use it."
   ],
   [
    "Shipping & returns",
    "No shipping costs, it's delivered by email. The mini they order later ships tracked, with our 14-day promise: if it arrives damaged, faulty or wrong, we remake it or refund it."
   ]
  ]
 },
 "house": {
  "desc": "Your home, sculpted by hand as a little ornament, down to the front door and the windows. Add your family name or an address line to make it yours. A lovely gift for a first home, a move or the house you grew up in.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your house by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the house, a free proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear photo of the front of the house, taken straight on. Extra photos of the sides or roof help us get the details right."
   ],
   [
    "What arrives at my door?",
    "Your house ornament with its ribbon, ready to hang, in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The hand-sculpted house ornament with a ribbon, your family name or address line for free, a free proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Hang it on a sturdy branch or hook. Store it wrapped in soft tissue in its box."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "wine-opener": {
  "desc": "A classic T-handle corkscrew with their face sculpted by hand on top of the wooden handle, so they open every bottle with a smile. Hand-built from your photo, hair and freckles included. Perfect for the wine lover or the host who has everything.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the head by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the opener, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face is the most important one. A side profile helps the likeness too."
   ],
   [
    "What arrives at my door?",
    "Your wine opener with their face on top, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The T-handle corkscrew with their head sculpted by hand on top, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The head is about 2 inches tall, hand-built in non-toxic polymer clay, painted by hand and sealed, on a wooden handle with a steel spiral. Real clay, no 3D printing. Only the steel touches the cork."
   ],
   [
    "Care tips",
    "Wipe the corkscrew clean with a damp cloth. Keep the clay head out of water and the dishwasher."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "dashboard": {
  "desc": "Their face, sculpted by hand on a head that sits on a spring, made to ride along on the car dashboard. It nods along on every drive. A fun gift for a new driver, a commuter or anyone who basically lives in their car.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the figure by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the figure, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing face photo. A side profile helps the likeness too."
   ],
   [
    "What arrives at my door?",
    "Your dashboard head on its spring and base, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The hand-sculpted dashboard figure on its base, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Set it on a flat spot where it won't slide. Keep it out of strong direct sun: a parked car gets very hot, colors can fade and the sticky pad can let go. If it loosens, re-stick it with a fresh pad. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "pet-frame": {
  "desc": "Your pet's head, sculpted by hand in relief and set in a frame for the wall. Every bit of fur and that happy face, ready to hang above the couch. Made for dog and cat people who want their pet front and center.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your pet by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish your pet, a free proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face. A second angle helps us nail the markings."
   ],
   [
    "What arrives at my door?",
    "Your pet's portrait in its frame, ready for the wall, in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "Your pet's head, sculpted by hand in relief and framed, a free proof and a gift box."
   ],
   [
    "Size & materials",
    "The pet portrait is hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Hang it on a solid hook away from steamy rooms and strong direct sun. Dust it gently with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "pet-cake-topper": {
  "desc": "Your pet, sculpted by hand and ready to sit on top of the birthday cake, fork in paw. It's not edible, so lift it off before the cake is cut. It's the funniest guest at the party and stays on the shelf long after the cake is gone. A great pick for pet birthdays and gotcha days.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your pet by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else. Order ahead of the party so there's time for the proof."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish your pet, a free proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear face photo and a full-body photo of your pet. A second angle helps us nail the markings."
   ],
   [
    "What arrives at my door?",
    "Your pet cake topper, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "Your pet, sculpted by hand as a cake topper, a free proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing. Not edible: polymer clay is not food safe."
   ],
   [
    "Care tips",
    "Not edible. Lift it off before you cut the cake, then keep it as a keepsake. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "music-box": {
  "desc": "A wind-up music box base for your mini, so the figures sit on top while a tune plays. It turns a mini into a little moment, perfect for anniversaries, grandparents and first dances.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the mini on top by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the mini, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing face photo and a full-body photo of each person on top, in the outfits you want."
   ],
   [
    "What arrives at my door?",
    "Your mini on its music box base, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The music box base for your mini, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "A wind-up music box base. The figures on top are hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Wind it gently and stop when you feel it tighten. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "pet-necklace": {
  "desc": "A round pendant with your pet's face sculpted by hand in clay, on a chain to wear every day. Small enough to keep them close wherever you go. A sweet gift for pet moms, and a gentle memorial too.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your pet by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the pendant, a free proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face. A second angle helps us nail the markings."
   ],
   [
    "What arrives at my door?",
    "Your pet necklace, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The pendant with your pet's face sculpted by hand, on a chain, a free proof and a gift box."
   ],
   [
    "Size & materials",
    "The pet's face is hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Take it off before showering, swimming or sleeping. Wipe it with a soft dry cloth."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "photo-clip": {
  "desc": "A full-body mini of them on a base, holding a tall clip for a photo, note or place card. Swap the picture whenever you like. A fun desk gift for a graduate, a new job or a proud grandparent.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the mini by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the mini, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing face photo and a full-body photo in the outfit you want. A side profile helps the likeness too."
   ],
   [
    "What arrives at my door?",
    "Your photo clip mini on its base, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The hand-sculpted mini on its base with a photo clip, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Slide photos in and out gently so the clip stays straight. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "toy-box": {
  "desc": "Your mini in action-figure box packaging, like a collectible straight off the toy shelf. Their own job, outfit and props make it feel like a real limited edition. Made for doctors, nurses, teachers and anyone who deserves their own action figure.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the mini by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the mini, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing face photo and a full-body photo in the outfit you want, like scrubs or a uniform. Tell us any props."
   ],
   [
    "What arrives at my door?",
    "Your mini in its action-figure box, in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The action-figure box packaging for your mini, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The figure inside is hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Keep it on a shelf out of strong direct sun so the box colors stay bright."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "kids-badge": {
  "desc": "A round badge with your child's face sculpted by hand in clay, made for a proud parent's or grandparent's coat. Braids, freckles and that big smile, all in one little piece. It's a keepsake for grown-ups to wear, not a toy, so keep it away from little hands.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the badge by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the badge, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face, smiling if you can. Good light helps us get the details."
   ],
   [
    "What arrives at my door?",
    "Your face badge, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The badge with your child's face sculpted by hand, a pin back, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing. Made for adults: it has a pin back and small parts, so it's not for children."
   ],
   [
    "Care tips",
    "Take it off before the coat goes in the wash. Wipe it with a soft dry cloth."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "hair-tie": {
  "desc": "A soft scrunchie with a tiny clay version of their face on it, sculpted by hand from your photo. It turns every ponytail into a little portrait. A sweet gift for daughters, nieces and best friends.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the face by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the hair tie, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face. Show us the hairstyle you want too."
   ],
   [
    "What arrives at my door?",
    "Your hair tie with its clay face, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The scrunchie with a hand-sculpted clay face, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The face is hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Don't put it in the washing machine. Keep the clay face out of water and take it off before swimming or bath time."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "fork-spoon": {
  "desc": "A fork and a spoon with family faces sculpted by hand at the very end of the handles. It's a keepsake to display on a shelf or keep in a memory box, not cutlery for meals. A sweet gift for couples, new families and grandparents.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the faces by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the set, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of each face you want on the handles. One family photo works if every face is clear."
   ],
   [
    "What arrives at my door?",
    "Your fork and spoon keepsake set, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "A fork and a spoon with faces sculpted by hand at the end of the handles, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "The faces are hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing. Polymer clay is not food safe, so the set is for display only."
   ],
   [
    "Care tips",
    "Keep it on display, away from food, water and the dishwasher. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "pet-bed": {
  "desc": "A pet bed base for your pet mini, so they can curl up in a banana bed, dog bed or cat bed. It's the cozy finishing touch that makes the mini feel like home. Made for pets who love their bed more than anything.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your pet's mini by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish your pet, a free proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear face photo and a full-body photo of your pet. A photo of them lying down helps us get the pose right."
   ],
   [
    "What arrives at my door?",
    "Your pet mini in its bed base, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The pet bed base for your pet mini: banana bed, dog bed or cat bed. A free proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Dust it with a soft dry brush and keep it out of reach of real paws."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "big-vehicle": {
  "desc": "Your mini at the wheel of a tractor, or riding a train, on its own base. For the farmer, the railway fan or the grandpa who still talks about his first tractor. Every wheel and detail is sculpted by hand.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the vehicle and your mini by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish your mini, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing face photo and a full-body photo. A photo of their real tractor or favorite train helps us match the colors."
   ],
   [
    "What arrives at my door?",
    "Your mini with the tractor or train on its base, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The tractor or train, sculpted by hand for your mini, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Pick it up by the base, not the vehicle. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "pet-urn": {
  "desc": "An urn for your pet's ashes, with a figure of them sculpted by hand on the lid. We sculpt your pet from your photo. Tell us their favorite pose in the note for the artist in your cart. A gentle way to keep them home, handled with extra care.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt your pet's figure by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish your pet, a free proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited. Memorial orders are handled with extra care."
   ],
   [
    "What photo should I send?",
    "A clear photo of their face and a full-body photo. Tell us their favorite pose in the note for the artist in your cart. A second angle helps us get the markings right, and older photos usually work too."
   ],
   [
    "What arrives at my door?",
    "Your pet urn with their figure on the lid, packed with care in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The urn with your pet's figure sculpted by hand on the lid, a free proof and a gift box."
   ],
   [
    "Size & materials",
    "The figure on the lid is hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Lift the lid with both hands, holding the edge, not the figure. Dust it with a soft dry brush."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 },
 "mag": {
  "desc": "Their face on the fridge, sculpted by hand in clay from your photo. A small, cheerful magnet that holds the shopping list, the kids' drawings or the save-the-date. A sweet extra with a mini, or a little gift on its own.",
  "faq": [
   [
    "How long until it's in my hands?",
    "We sculpt the magnet by hand first, usually 10 to 14 business days at the bench. Then it ships tracked: 8 to 14 business days in the US, 5 to 10 to the UK and Europe, 6 to 20 everywhere else."
   ],
   [
    "Do I see it before it's finished?",
    "Yes. Before we finish the magnet, a free face proof lands in your inbox, photographed from a few angles. We change it until you love it, free and unlimited."
   ],
   [
    "What photo should I send?",
    "A clear, front-facing photo of their face, smiling if you can. Good light helps us get the details. Ordering it with a mini? We use the same photo."
   ],
   [
    "What arrives at my door?",
    "Your fridge magnet, packed in a gift box and sent tracked."
   ]
  ],
  "details": [
   [
    "What's included",
    "The magnet with their face sculpted by hand, a free face proof and a gift box."
   ],
   [
    "Size & materials",
    "Hand-built in non-toxic polymer clay, oven-cured, painted by hand and sealed, with a magnet on the back. Real clay, no 3D printing."
   ],
   [
    "Care tips",
    "Keep it out of direct sun and away from the stove. Wipe it with a soft dry cloth."
   ],
   [
    "Shipping & returns",
    "Tracked shipping: US $14.95 (free over $249), UK and Europe $16.95, rest of world $19.95. Arrived damaged, faulty or wrong? Email us within 14 days with photos and we remake it or refund you. It's made just for you, so it can't come back for a change of mind."
   ]
  ]
 }
};
